import Checkbox from 'components/inputs/checkbox';
import { FilterOption } from './equipment-filter-section-types';

type FilterSectionProps<T> = Readonly<{
  title?: string;
  options: ReadonlyArray<FilterOption<T>>;
  enabled: Set<T>;
  onToggle: (value: T) => void;
}>;

export default function FilterSection<T>({
  title,
  options,
  enabled,
  onToggle
}: FilterSectionProps<T>) {
  if (options.length < 2) return null;
  return (
    <div>
      {title && (
        <div className='mb-2 text-xs font-semibold uppercase tracking-wider text-gray-500'>
          {title}
        </div>
      )}
      <div className='flex flex-col gap-2'>
        {options.map((option) => {
          const checked = enabled.has(option.value);
          const isOnlyEnabled = checked && enabled.size === 1;
          return (
            <label
              key={option.htmlId}
              htmlFor={option.htmlId}
              className='flex cursor-pointer items-start gap-2 rounded-md p-1 hover:bg-gray-50'
            >
              <Checkbox
                htmlId={option.htmlId}
                value={checked}
                onChange={() => onToggle(option.value)}
                disabled={isOnlyEnabled}
              />
              <div className='flex flex-col'>
                <span className='text-sm font-medium text-gray-900'>
                  {option.label}
                  {option.count !== undefined && (
                    <span className='font-normal text-gray-400'>
                      {' '}
                      ({option.count})
                    </span>
                  )}
                </span>
                {option.description && (
                  <span className='text-xs text-gray-500'>
                    {option.description}
                  </span>
                )}
              </div>
            </label>
          );
        })}
      </div>
      {enabled.size === 1 && (
        <div className='mt-2 text-xs text-gray-400'>
          At least one option must remain selected.
        </div>
      )}
    </div>
  );
}
